import { request } from "../../httpClient";

export const restoreUserRequest = async (id) => {
  const res = await request({
    path: "user/protected/user-restore",
    method: "POST",
    body: JSON.stringify({ id: id }),
  });
  return res;
};
